import { render } from "./BeritaDetail.vue?vue&type=template&id=7966c900"
import script from "./BeritaDetail.vue?vue&type=script&lang=js"
export * from "./BeritaDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\helmi\\blitarenergi\\vue\\companyprofile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__